import {AddressDto, RegionType} from "@/generated/openapi/api"
import {AutocompleteAddressData} from "@/models/AutocompleteAddressData";
import {GISGeoname} from "@/models/GISGeoname";
import axios, {AxiosRequestConfig} from "axios"
import qs from "qs";

const baseOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_GIS_API_URL,
  paramsSerializer: params => {
    console.debug('serializing', params)
    return qs.stringify(params, { indices: false, skipNulls: true })
  }
}

const httpClient = axios.create(baseOptions)

class AddressService {

  getAddressFromGisGeoname(geoName: GISGeoname): AddressDto {
    const address = {} as AddressDto
    address.areaCode = geoName.PGNR
    address.city = geoName.ORT
    address.houseNumber = geoName.HAUSNR
    const tmpRegion = this.getRegionTypeForAreaCode(geoName.PGNR)
    if(tmpRegion !== undefined) {
      address.region = tmpRegion
    }
    address.streetName = geoName.STRASSE
    address.zipCode = geoName.PLZ
    return address
  }

  /**
   * Nimmt die erste Stelle des Area-Code (bzw. PG-Nummer) und ermittelt daraus das Bundesland
   * @param areaCode
   * @returns
   */
  public getRegionTypeForAreaCode(areaCode: string): RegionType | undefined {
    if(areaCode === undefined || areaCode.length < 1) {
      return undefined
    }
    switch(areaCode.substring(0,1)) {
      case "1": return RegionType.Burgenland
      case "2": return RegionType.Carinthia
      case "3": return RegionType.LowerAustria
      case "4": return RegionType.UpperAustria
      case "5": return RegionType.Salzburg
      case "6": return RegionType.Styria
      case "7": return RegionType.Tyrol
      case "8": return RegionType.Vorarlberg
      case "9": return RegionType.Vienna
    }
    return undefined;
  }

  async getAutocompleteAddress(searchString: string, count = 10): Promise<Array<GISGeoname>> {
    try {
      searchString = this.escapeSpecialCharsForAddressService(searchString)
      const uri = "AddressSearchIndividual?q=" + searchString + "&num=" + count
      const response = await httpClient.get(encodeURI(uri))
      return response.data.geonames;
    } catch (e) {
      throw new Promise(r => r);
    }
  }

  getAddressesBySearchString(searchString: string, count = 10): Promise<Array<AutocompleteAddressData>> {
    return this.getAutocompleteAddress(searchString, count).then(geoNames => {
      return geoNames.map(geoName => {
        const data = {} as AutocompleteAddressData
        data.address = this.getAddressFromGisGeoname(geoName)
        data.gis = geoName
        return data
      })
    })
  }

  escapeSpecialCharsForAddressService(searchString: string) : string {
    if(searchString) {
      // there seems to be a character set bug in the address abfrage
      searchString = searchString.replaceAll("ß", "ss")
          .replaceAll("ä", "ae")
          .replaceAll("ö", "oe")
          .replaceAll("ü", "ue")
    }
    return searchString
  }

}



const addressService = new AddressService()
export default addressService
